import { render } from "./createtwo.vue?vue&type=template&id=46e3abb6&scoped=true"
import script from "./createtwo.vue?vue&type=script&lang=js"
export * from "./createtwo.vue?vue&type=script&lang=js"

import "./createtwo.vue?vue&type=style&index=0&id=46e3abb6&lang=less"
import "./createtwo.vue?vue&type=style&index=1&id=46e3abb6&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e3abb6"]])

export default __exports__